import styled, {css} from 'styled-components';

import {Icon} from '../../../ui-toolkit/elements/Icon/Icon';

const Status = styled.span`
    padding: 2px 8px 1px;
    vertical-align: middle;
    display: inline-flex;
    align-items: center;
    gap: var(--space-xsm);
    position: relative;
    font-weight: 400;
    margin: 0;
    color: var(--default-text-color);
    border: none;
    border-radius: 4px;

    ${Icon.Wrapper} {
        margin-bottom: 2px !important;
        svg {
            width: 14px !important;
            height: 14px !important;
        }
    }

    ${({color}) => {
        if (!color) return css;

        return css`
            color: ${color};
        `;
    }}

    ${({bgcolor}) => {
        if (!bgcolor) {
            return css`
                padding: 0;
            `;
        }

        return css`
            background-color: ${bgcolor};
        `;
    }}
`;

export default Status;
